import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, interval, map } from 'rxjs';

@Component({
  selector: 'app-stopwatch',
  templateUrl: './stopwatch.component.html',
  styleUrls: ['./stopwatch.component.scss'],
})
export class StopwatchComponent implements OnInit, OnDestroy {
  @Input() component: 'LOT' | 'AUCTION' | 'SCREEN' = 'SCREEN';
  @Input() label!: string;
  @Input() finish_date!: string;
  @Input() last_bid!: string;
  @Input() time_bid = 0;
  @Input() color = '#000';
  @Input() full_team = false;
  @Output() eventChange = new EventEmitter();

  currentTime$: Observable<number> | undefined;

  ngOnInit() {
    // window.requestAnimationFrame()

    this.currentTime$ = interval(1000).pipe(
      map(() => {
        return this.validateAuctionTime()
      })
    );
  }

  validateAuctionTime(){
    const now = new Date();
    let finalDate = new Date(this.finish_date);

    const newFinal = new Date(this.last_bid);
    newFinal.setMinutes(newFinal.getMinutes() + this.time_bid);

    // Se a data final for anterior ao último lance, ajuste para o último lance
    if (new Date(this.finish_date) < new Date(newFinal)) {
        finalDate = new Date(newFinal);
    }

    // Adicione o tempo do lance ao final date
    finalDate.setMinutes(finalDate.getMinutes());

    // Calcular a diferença entre o momento atual e a hora final
    const diff = finalDate.getTime() - now.getTime();

    // Calcular o tempo restante em segundos
    const seconds = Math.floor(diff / 1000);

    this.eventChange.emit({seconds, component: this.component});

    // Garantir que o tempo restante seja positivo para evitar valores de tempo negativos
    return Math.max(seconds, 0);
  }

  ngOnDestroy() {
    this.currentTime$ = undefined;
  }
}
